module.exports = __webpack_public_path__ + "img/131.dd7679f1.jpg";